import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";

import api from "../../../service/api";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Main from "../../../components/Main";
import ModalActions from "../../../components/ModalActions";
import Table from "../../../components/Table";
import DropdownButton from "../../../components/DropdownButton";
import SideContainer from "../../../components/SideContainer/styles";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import Select from "../../../components/Select";

import { 
    THead, 
    Th, 
    ThFilterable, 
    Legend, 
    Td, 
    InputWithHintContainer, 
    Title, 
    Line, 
    FirstColumn, 
    AnotherColumn, 
    InfoTitle, 
    InfoData 
} from "./styles";

import routes from "../../../routes/plans.routes";

import {recurrenceData} from "../../../data/provisionalData";

//Utils
import { translateFrequencyOrInterval } from "../../../utils/translate/frequencyOrInterval";
import { translatePaymentType } from "../../../utils/translate/paymentType";

//Assets
import addRecurrence from "../../../assets/icons/addRecurrence.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import search from "../../../assets/icons/search.svg";
import hint from "../../../assets/icons/hint.svg";

const Recorrency = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  
  const [recurrenceData, setRecurrenceData] = useState<Array<any>>([]);
  const [selectedRecurrencePlan, setSelectedRecurrencePlan] = useState({
    pl_id: "",
    br_id: "",
    pl_name: "",
    pl_frequency: "",
    pl_isActive: "",
    pl_interval: "",
    pl_paymentMethods: "",
    pl_amount: 0,
    pl_setupAmount: 0,
    br_businessName: "",
    pl_created_at: "",
    pl_updated_at: "",
    pl_gracePeriod: "",
    pl_tolerancePeriod: "",
    pl_duration: ""
  })

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();

  useEffect(() => {
    if(login.user.groups.am4a2){
        history.push("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    const getRecurrenceData = async () => {
        const {data} = await api.get("/adm/owner100pay/list", {
            params: {
                plans: login.user.ownersId,
                page
            }
        });
        
        setMaxPage(data.pageCount);
        setRecurrenceData(data["Recurrence Plan"]);
    }

    getRecurrenceData();
  }, [page]);

  const openAddForm = () => {
    if (isEditFormVisible !== true) {
      setIsAddFormVisible(true);
    }
  };

  const openEditForm = () => {
    if (isAddFormVisible !== true) {
      setIsEditFormVisible(true);
    }
  };

  const tableContentGenerator = () => {
    return recurrenceData.map((plan) => {
        return(
            <tr key={plan.pl_id} style={{ height: 67 }}>
                <Td>{plan.pl_id}</Td>
                <Td>{plan.br_businessName}</Td>
                <Td>{plan.pl_name}</Td>
                <Td>{translateFrequencyOrInterval(plan.pl_frequency)}</Td>
                <Td>{plan.pl_isActive === true ? "Ativo" : "Inativo"}</Td>
                <Td>{plan.pl_interval}</Td>
                <Td>{translatePaymentType(plan.pl_paymentMethods)}</Td>
                <Td>{(plan.pl_amount / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</Td>
                <Td>{(plan.pl_setupAmount / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</Td>
                <Td>
                    <DropdownButton 
                        selectedUser={plan}
                        setSelectedUser={setSelectedRecurrencePlan}
                        isViewOptionVisible={true}
                        setIsEditFormVisible={openEditForm} 
                        openModal={true} 
                        modalId="#details-plans"
                    />
                </Td>
            </tr>
        )
    });
  };

  const formValidationWithYup = Yup.object().shape({
    planName: Yup.string().required(),
    planDescription: Yup.string().required(),
    frequence: Yup.string().required(),
    interval: Yup.string().required(),
    paymentMethod: Yup.string().required(),
    gracePeriod: Yup.string().required(),
    planValue: Yup.string().required(),
    setupValue: Yup.string().required(),
    tolerance: Yup.string().required(),
    planDuration: Yup.string().required()
  });
  
  const openForm = isAddFormVisible || isEditFormVisible;

    return(
        <div className="d-flex">
            {//login.user.groups.am4a2r
                    <ModalActions title="Informações do plano" subtitle={`Última atualização ${moment(selectedRecurrencePlan.pl_created_at).format("DD/MM/YYYY hh:mm")}`} id="details-plans">
                        <Title>Dados Principais</Title>
                        <Line>
                            <FirstColumn style={{width: 300, paddingRight: 15, wordBreak: "break-all"}}>
                                <InfoTitle>Nome</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.br_businessName}</InfoData>
                            </FirstColumn>
                            <div>
                                <InfoTitle>Descrição</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.pl_name}</InfoData>
                            </div>
                        </Line>
                        <Line>
                            <FirstColumn style={{width: 300}}>
                                <InfoTitle>Data de criação</InfoTitle>
                                <InfoData>{moment(selectedRecurrencePlan.pl_created_at).format("DD/MM/YYYY hh:mm")}</InfoData>
                            </FirstColumn>
                            <AnotherColumn>
                                <InfoTitle>Frequência</InfoTitle>
                                <InfoData>{translateFrequencyOrInterval(selectedRecurrencePlan.pl_frequency)}</InfoData>
                            </AnotherColumn>
                            <AnotherColumn>
                                <InfoTitle>Intervalo</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.pl_interval}</InfoData>
                            </AnotherColumn>
                        </Line>
                        <Line>
                            <FirstColumn style={{width: 300}}>
                                <InfoTitle>Período de Carência</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.pl_gracePeriod}</InfoData>
                            </FirstColumn>
                            <AnotherColumn>
                                <InfoTitle>Tolerância na Falha</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.pl_tolerancePeriod}</InfoData>
                            </AnotherColumn>
                            <AnotherColumn>
                                <InfoTitle>Duração do Plano</InfoTitle>
                                <InfoData>{selectedRecurrencePlan.pl_duration}</InfoData>
                            </AnotherColumn>
                        </Line>
                        <Line>
                            <FirstColumn style={{width: 300}}>
                                <InfoTitle>Valor do Plano</InfoTitle>
                                <InfoData>R$ {(selectedRecurrencePlan.pl_amount / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</InfoData>
                            </FirstColumn>
                            <AnotherColumn>
                                <InfoTitle>Valor do Setup</InfoTitle>
                                <InfoData>R$ {(selectedRecurrencePlan.pl_setupAmount / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</InfoData>
                            </AnotherColumn>
                        </Line>
                        <Line>
                            <div>
                                <InfoTitle>Métodos de Pagamento</InfoTitle>
                                <InfoData>Crédito</InfoData>
                            </div>
                        </Line>
                    </ModalActions>
            }
            <Main
                className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
                isFormVisible={isAddFormVisible}
            >
                <Header title="Planos" subTitle="Gerencie todos os planos de recorrência do sistema" subTitleWidth={182}/>
                <NavTabs tabs={routes}/>

                <Table
                    buttonText="Adicionar Plano"
                    isAddFormVisible={isAddFormVisible}
                    setIsAddFormVisible={openAddForm}
                    showAddButton={login.user.groups.am4a2c}
                    showExportButton={login.user.groups.am4a2e}
                    page={page}
                    maximumPage={maxPage}
                    setPage={setPage}
                >
                    <THead>
                        <tr>
                            <Th>
                                <ThFilterable>
                                    <div>ID</div>
                                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                                        <img src={upArrow} alt="seta para cima" />
                                        <br />
                                        <img src={downArrow} alt="seta para baixo" />
                                    </div>
                                </ThFilterable>
                            </Th>
                            <Th>
                                <ThFilterable>
                                    <div>Nome do Vendedor</div>
                                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                                        <img src={upArrow} alt="seta para cima" />
                                        <br />
                                        <img src={downArrow} alt="seta para baixo" />
                                    </div>
                                </ThFilterable>
                            </Th>
                            <Th>Plano</Th>
                            <Th>
                                <ThFilterable>
                                    <div>Frequência</div>
                                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                                        <img src={upArrow} alt="seta para cima" />
                                        <br />
                                        <img src={downArrow} alt="seta para baixo" />
                                    </div>
                                </ThFilterable>
                            </Th>
                            <Th>
                                <ThFilterable>
                                    <div>Status</div>
                                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                                        <img src={upArrow} alt="seta para cima" />
                                        <br />
                                        <img src={downArrow} alt="seta para baixo" />
                                    </div>
                                </ThFilterable>
                            </Th>
                            <Th>Intervalo</Th>
                            <Th>Método de Pagamento</Th>
                            <Th>Valor do plano</Th>
                            <Th>Valor do Setup</Th>
                            <Th></Th>
                        </tr>
                    </THead>
                    <tbody>{tableContentGenerator()}</tbody>
                </Table>
            </Main>

            <SideContainer visible={isAddFormVisible} className="column-side">
                <SideForm
                    title="Adicionar Plano"
                    icon={addRecurrence}
                    visible={() => setIsAddFormVisible(false)}
                >
                    <Formik 
                        initialValues={{
                            planName: "",
                            planDescription: "",
                            frequence: "",
                            interval: "",
                            paymentMethod: "",
                            gracePeriod: "",
                            planValue: "",
                            setupValue: "",
                            tolerance: "",
                            planDuration: ""
                        }}
                        validationSchema={formValidationWithYup}
                        onSubmit={() => {}}
                    >
                    {({}) => {
                        return(
                            <Form id="form-subscription" style={{ width: "100%", marginTop: 41 }}>
                                <div className="inputWithIcon">
                                    <Input className="inputCustom" placeholder="Vendedor"/>
                                    <img src={search} alt="Procurar"/>
                                </div>
                                <fieldset>
                                    <Legend>Dados Principais</Legend>
                                    <Field id="planName" name="planName" className="inputCustom" placeholder="Nome do Plano" as={Input}/>
                                    <Field id="planDescription" name="planDescription" className="inputCustom" placeholder="Descrição"  as={Input}/>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <InputWithHintContainer>
                                                <Field id="frequence" name="frequence" style={{marginBottom: 0}} as={Select}>
                                                    <option>Frequência</option>
                                                    <option>Diário</option>
                                                    <option>Semanal</option>
                                                    <option>Mensal</option>
                                                </Field>
                                                <img src={hint} style={{marginLeft: 3}} alt=""/>
                                            </InputWithHintContainer>
                                        </div>
                                        <div className="col-lg-6">
                                            <InputWithHintContainer>
                                                <Field id="interval" name="interval" placeholder="Intervalo" type="number" as={Input}/>
                                                <img src={hint} style={{marginLeft: 3}} alt=""/>
                                            </InputWithHintContainer>
                                        </div>
                                    </div>
                                    <InputWithHintContainer>
                                        <Field id="paymentMethod" name="paymentMethod" style={{marginBottom: 0}} as={Select}>
                                            <option>Método de pagamento</option>
                                            <option>Crédito</option>
                                            <option>Boleto</option>
                                        </Field>
                                        <img src={hint} style={{marginLeft: 3}} alt=""/>
                                    </InputWithHintContainer>
                                    <InputWithHintContainer>
                                        <Field id="gracePeriod" name="gracePeriod" placeholder="Período de Carência" type="number" as={Input}/>
                                        <img src={hint} style={{marginLeft: 3}} alt=""/>
                                    </InputWithHintContainer>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <InputWithHintContainer>
                                                <Field id="planValue" name="planValue" placeholder="Valor do Plano" as={Input}/>
                                                <img src={hint} style={{marginLeft: 3}} alt=""/>
                                            </InputWithHintContainer>
                                        </div>
                                        <div className="col-lg-6">
                                            <InputWithHintContainer>
                                                <Field id="setupValue" name="setupValue" placeholder="Valor do Setup" type="number" as={Input}/>
                                                <img src={hint} style={{marginLeft: 3}} alt=""/>
                                            </InputWithHintContainer>
                                        </div>
                                    </div>
                                    <InputWithHintContainer>
                                        <Field id="tolerance" name="tolerance" placeholder="Tolerância na Falha" type="number" as={Input}/>
                                        <img src={hint} style={{marginLeft: 3}} alt=""/>
                                    </InputWithHintContainer>
                                    <InputWithHintContainer>
                                        <Field id="planDuration" name="planDuration" placeholder="Duração do Plano" type="number" as={Input}/>
                                        <img src={hint} style={{marginLeft: 3}} alt=""/>
                                    </InputWithHintContainer>
                                </fieldset>
                            
                                <Button
                                    className="buttonCustom"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                >
                                    Adicionar
                                </Button>
                            </Form>
                        )
                    }}
                    </Formik>
                </SideForm>
                </SideContainer>
        </div>
    )
}

export default Recorrency;